export default __webpack_public_path__ + "static/media/s12.a4d3b32d.png";